import { useHistory, useLocation } from 'react-router-dom';

export const useSelectedCommitment = () => {
  const history = useHistory();

  const { search, pathname } = useLocation();
  const commitmentId = new URLSearchParams(search).get('commitment');

  const setCommitmentId = (commitmentId?: string) => {
    const params = new URLSearchParams(search);

    if (commitmentId) {
      params.set('commitment', commitmentId);
    } else {
      params.delete('commitment');
    }

    history.replace({
      pathname,
      search: params.toString(),
    });
  };

  return {
    setCommitmentId,
    commitmentId,
  };
};
